import { render, staticRenderFns } from "./goodsOrderList.vue?vue&type=template&id=b2ccf5b4&"
import script from "./goodsOrderList.vue?vue&type=script&lang=js&"
export * from "./goodsOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports